import { AIApi } from '@liks/backend-svc-api/esm/apis/AIApi';
import type { CostSettings } from '@liks/backend-svc-api/esm/models/index';
import { backendApiConfiguration } from './backendApi';

export type { CostSettings };

class TenantCostService {
  private readonly aiApi = new AIApi(backendApiConfiguration);

  async getCostSettings(): Promise<CostSettings> {
    return this.aiApi.deLiksAiBoundaryTokenCounterResourceReadCostSettings();
  }
}

export const tenantCostService = new TenantCostService();
